import React from "react";

export const TableCell: React.FC<any> = ({ children }) => {
  return <div className={`py-3 px-4 whitespace-nowrap border-t border-fg-gray-surface h-16 flex items-center`}>
    {children}
  </div>
}